type ProjectStatusCardProps = {
  readonly statusName: string;
  readonly value: number | undefined;
  readonly icon: string | JSX.Element;
  readonly iconBackground: string;
};
export const ProjectStatusCard = ({
  statusName,
  value,
  icon,
  iconBackground,
}: ProjectStatusCardProps) => {
  return (
    <div className="flex h-[88px] w-full items-center gap-3 px-4 py-14">
      <div className={`rounded-full ${iconBackground} p-3 text-xl`}>{icon}</div>
      <div className="flex flex-col">
        <span className="text-xl font-normal text-black">{value ?? 0}</span>
        <span className="text-sm font-normal text-gray-500">{statusName}</span>
      </div>
    </div>
  );
};
